import React, { Suspense } from 'react';
import { BrowserRouter as Router, withRouter } from 'react-router-dom';
import { Layout } from 'antd';
import Sidebar from './components/layout/Sidebar';
import Navbar from './components/layout/Navbar';
import variables from './assets/styles/variables';
import { connect } from 'react-redux';
import Footer from './components/layout/Footer';
import Routes from './navigation/Routes';
import ScrollToTop from './components/layout/ScrollToTop';
import PageLoader from './components/PageLoader';
import Helmet from 'react-helmet';

const Content = withRouter((props) => {
	return (
		<Layout>
			<Layout.Header>
				<Navbar />
			</Layout.Header>
			<Layout>
				{props.loggedIn && (
					<Layout.Sider
						width={variables.SidebarSize}
						collapsedWidth={0}
						zeroWidthTriggerStyle={{ bottom: '0', top: 'unset' }}
						collapsible
					>
						<Sidebar />
					</Layout.Sider>
				)}
				<Layout.Content>
					<Suspense fallback={<PageLoader />}>
						<Routes auth={props.loggedIn} />
					</Suspense>
				</Layout.Content>
			</Layout>
			<Layout.Footer>
				<Footer />
			</Layout.Footer>
		</Layout>
	);
});

const App = (props) => (
	<Router>
		<Helmet>
			<meta name="theme-color" content={variables.ThemeColor} />
			<body />
		</Helmet>
		<Content {...props} />
		<ScrollToTop />
	</Router>
);

const mapStateToProps = (state) => ({
	loggedIn: state.session.loggedIn,
});

export default connect(mapStateToProps)(App);
